import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';

import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';
import { RightSidePanelService } from 'src/shared/providers/providers/right-side-panel';
import { TidyStorage } from 'src/shared/providers/tidy-storage';
import { WindowService } from 'src/shared/providers/window.service';
import { Util } from 'src/shared/util/util';

@Component({
  templateUrl: 'send-for-signature.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SendForSignaturePage implements OnInit {
  private navCtrl = inject(CustomNavController);
  private rightSidePanelService = inject(RightSidePanelService);
  private storage = inject(TidyStorage);
  private fb = inject(UntypedFormBuilder);
  private util = inject(Util);

  readonly windowService = inject(WindowService);

  form: UntypedFormGroup;
  submitted = false;
  isRightSideContent = true;
  dialogParams: any;
  errorMessage: string;
  loaded = false;
  sendAction = () => this.send();

  constructor() {
    this.form = this.fb.group({
      recipientName: ['', Validators.required],
      recipientEmail: ['', [Validators.required, Validators.email]],
    });
  }

  async ngOnInit() {
    this.isRightSideContent = await this.storage.retrieve('dialog-right-side-open') || false;
    this.dialogParams = await this.storage.retrieve('dialog-params');
    if (this.isRightSideContent) {
      this.rightSidePanelService.setDialogPageTitle('Send for E-Signature');
    }
    this.loaded = true;
  }

  async send() {
    this.submitted = true;
    if (!this.form.valid) {return;}
    try {
      this.util.showSuccess('E-signature request sent successfully.');
      if (this.isRightSideContent) {
        this.rightSidePanelService.closeRightSidePanel();
      } else {
        this.navCtrl.navigateBack('compliance');
      }
    } catch (err) {
      this.errorMessage = (err.error?.message) || err.message;
    }
  }
}
